export default {
	KDB: 'kdb-context',
	FOUNDERS: 'founders-context'
};
